<template>
  <v-app>
    <core-app-bar />

    <core-drawer />

    <core-view-member-view />

    <core-footer />

  </v-app>
</template>

<script>
export default {
  name: 'ViewMember',

  components: {
    CoreAppBar: () => import('../components/core/AppBar'),
    CoreDrawer: () => import('../components/core/Drawer'),
    CoreViewMemberView: () => import('../components/core/ViewMemberView'),
    CoreFooter: () => import('../components/core/Footer'),
  },

  data: () => ({
    expandOnHover: false,
  }),
}
</script>
